"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const Yup = __importStar(require("yup"));
const IValidation_1 = require("./IValidation");
const helper_1 = require("./helper");
exports.dataFormatterSchema = Yup.object().shape({
  type: Yup.string().required("Formatting Type is required"),
  selectKeys: Yup.object().required(),
  customKeys: Yup.array().of(
    Yup.object().shape({
      key: Yup.string().required("Label is required"),
      value: Yup.string().required("Value is required"),
      type: Yup.string().required()
    })
  )
});
class DataFormatterNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    return helper_1.isValid(
      [
        { schema: exports.dataFormatterSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        { schema: IValidation_1.selectedResourceSchema, data: selectedResource }
      ],
      node.getNodeId()
    );
  }
}
exports.DataFormatterNodeValidation = DataFormatterNodeValidation;
//# sourceMappingURL=DataFormatterNodeValidation.js.map
